import template from './print_batch.html'
import controller from './print_batch.controller'
import './print_batch.scss'

let printBatchComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default printBatchComponent;


// WEBPACK FOOTER //
// ./client/app/components/shipment_batch/print/print_batch.component.js